module.exports = "/assets/39cda0ce3501d178f4172f406240054d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JA.png
// module id = 2627
// module chunks = 0